module.exports = __webpack_public_path__ + "static/media/delete_forever-24px.95aa18f5.svg";